function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-10.359 0.002)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.359 -0.002)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M31.364,11.8a.674.674,0,0,1,0-.6l.858-1.755a2,2,0,0,0-.862-2.651l-1.725-.915a.674.674,0,0,1-.35-.482l-.337-1.924a2,2,0,0,0-2.255-1.639l-1.934.274a.674.674,0,0,1-.567-.184L22.788.565A2,2,0,0,0,20,.565L18.6,1.923a.674.674,0,0,1-.567.184L16.1,1.834A2,2,0,0,0,13.84,3.473L13.5,5.4a.674.674,0,0,1-.35.482l-1.725.915a2,2,0,0,0-.862,2.651l.858,1.755a.674.674,0,0,1,0,.6l-.858,1.755a2,2,0,0,0,.862,2.651l1.725.915a.674.674,0,0,1,.35.482l.337,1.924a2,2,0,0,0,1.968,1.659,2.051,2.051,0,0,0,.287-.02l1.934-.274a.674.674,0,0,1,.567.184L20,22.431a2,2,0,0,0,2.788,0l1.4-1.358a.675.675,0,0,1,.567-.184l1.934.274a2,2,0,0,0,2.255-1.639l.337-1.924a.674.674,0,0,1,.35-.482L31.36,16.2a2,2,0,0,0,.862-2.651ZM18.74,5.529a2.432,2.432,0,1,1-2.432,2.432A2.435,2.435,0,0,1,18.74,5.529ZM17.485,16.344a.663.663,0,0,1-.938-.938L25.3,6.652a.663.663,0,1,1,.938.938Zm6.561,1.123a2.432,2.432,0,1,1,2.432-2.432A2.435,2.435,0,0,1,24.047,17.468Z",
  transform: "translate(-10.359 0.002)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(22.941 13.93)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M291.557,310.141a1.105,1.105,0,1,0,1.105,1.105A1.107,1.107,0,0,0,291.557,310.141Z",
  transform: "translate(-290.452 -310.141)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(17.635 6.855)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M173.438,152.646a1.105,1.105,0,1,0,1.105,1.105A1.107,1.107,0,0,0,173.438,152.646Z",
  transform: "translate(-172.333 -152.646)"
})));

function SvgCoupons(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.069,
    height: 23,
    viewBox: "0 0 22.069 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupons);
export default __webpack_public_path__ + "static/media/coupons.f66f91e9.svg";
export { ForwardRef as ReactComponent };